import React, { useContext, useEffect } from "react";
import { useAlert } from "react-alert";
import { Redirect, Route, useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";

export const SpecialRoute = ({ role, isPrivate, ...props }) => {
  const { user, isLoading, ready } = useContext(AuthContext);
  const alert = useAlert();
  const { pathname: currentLocation, ...location } = useLocation();

  if (!ready) {
    return null;
  }

  if (isLoading || !ready) {
    return null;
  }

  if (role !== undefined && role !== user.data.roles.id) {
    alert.error("You are not allowed access to that page");
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: props.location },
        }}
      />
    );
  }

  // if (user && user.data.user.is_first_time === 1) {
  //   return (
  //     <Redirect
  //       to={{
  //         pathname: "/first-time-login",
  //         state: { from: props.location },
  //       }}
  //     />
  //   );
  // } else
  if (user && !isPrivate) {
    return (
      <Redirect
        to={{
          pathname: "/dashboard/index",
          state: { from: props.location },
        }}
      />
    );
  } else if (!user && isPrivate) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: props.location },
        }}
      />
    );
  } else {
    return <Route {...props} />;
  }
};

const AuthedRoute = (isPrivate) => (props) =>
  <SpecialRoute {...{ isPrivate, ...props }} />;

export const InternalRoute = AuthedRoute(true);
export const ExternalRoute = AuthedRoute(false);



// WEBPACK FOOTER //
// ./src/components/Auth.route.js